(() => {
  const SELECTORS = {
    slider: '[data-campta-slider]',
    slide: '[data-campta-slide]',
    previous: '[data-campta-previous]',
    next: '[data-campta-next]',
    dot: '[data-campta-dot]',
    rail: '[data-campta-rail]'
  };

  class CamptaSlider {
    constructor(element) {
      this.element = element;
      this.slides = [...element.querySelectorAll(SELECTORS.slide)];
      this.dots = [...element.querySelectorAll(SELECTORS.dot)];
      this.current = 0;
      this.startX = 0;
      this.startY = 0;
      if (this.slides.length < 2) return;
      this.bindEvents();
    }

    bindEvents() {
      this.element.querySelector(SELECTORS.previous)?.addEventListener('click', () => this.goTo(this.current - 1));
      this.element.querySelector(SELECTORS.next)?.addEventListener('click', () => this.goTo(this.current + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.camptaDot))));
      this.element.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.goTo(this.current - 1);
        if (event.key === 'ArrowRight') this.goTo(this.current + 1);
      });
      this.element.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.startX = event.clientX;
        this.startY = event.clientY;
      });
      this.element.addEventListener('pointerup', (event) => this.handleSwipe(event));
      this.element.addEventListener('pointercancel', () => { this.startX = 0; this.startY = 0; });
    }

    handleSwipe(event) {
      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;
      this.startX = 0;
      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      this.goTo(this.current + (deltaX < 0 ? 1 : -1));
    }

    goTo(index) {
      const next = (index + this.slides.length) % this.slides.length;
      if (next === this.current) return;
      this.slides[this.current].classList.remove('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.dots[this.current]?.classList.remove('is-active');
      this.dots[this.current]?.setAttribute('aria-current', 'false');
      this.current = next;
      this.slides[this.current].classList.add('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'false');
      this.dots[this.current]?.classList.add('is-active');
      this.dots[this.current]?.setAttribute('aria-current', 'true');
    }
  }

  class CamptaRail {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-campta-rail-track]');
      this.previous = element.querySelector('[data-campta-rail-previous]');
      this.next = element.querySelector('[data-campta-rail-next]');
      this.bindEvents();
      this.update();
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
    }

    bindEvents() {
      this.previous.addEventListener('click', () => this.scroll(-1));
      this.next.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.scroll(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.scroll(1); }
      });
    }

    scroll(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth * .85, behavior: 'smooth' });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const hasOverflow = maxScroll > 2;
      this.element.classList.toggle('has-overflow', hasOverflow);
      this.element.classList.toggle('is-at-end', !hasOverflow || this.track.scrollLeft >= maxScroll - 2);
      this.previous.disabled = !hasOverflow || this.track.scrollLeft <= 2;
      this.next.disabled = !hasOverflow || this.track.scrollLeft >= maxScroll - 2;
    }
  }

  const initialise = (root = document) => root.querySelectorAll(SELECTORS.slider).forEach((slider) => {
    if (!slider.dataset.camptaInitialised) {
      slider.dataset.camptaInitialised = 'true';
      new CamptaSlider(slider);
    }
  });

  const initialiseRails = (root = document) => root.querySelectorAll(SELECTORS.rail).forEach((rail) => {
    if (!rail.dataset.camptaRailInitialised) {
      rail.dataset.camptaRailInitialised = 'true';
      new CamptaRail(rail);
    }
  });

  document.addEventListener('DOMContentLoaded', () => { initialise(); initialiseRails(); });
  document.addEventListener('shopify:section:load', (event) => { initialise(event.target); initialiseRails(event.target); });
})();
